import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../helpers/constants'
import { logout } from '../helpers/methods'
import * as roles from '../store/roles';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPrivate } from '../store/auth';
import { NavHeader } from './inspinia';
import TemPermissao from '../helpers/TemPermissao';

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    static defaultProps =
        {
            navActiveItem: ""
        };

    handleLogout(e) {
        e.preventDefault(); if (this.state.loading) return;

        this.setState({ loading: true });

        logout(this.props).then(() => { this.setState({ loading: false }); });
    }

    render() {
        const auth = this.props.auth;
        const possuiPermissaoGestorCarimboTempo = (this.props.auth.user.papel.includes(roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO) && this.props.auth.user.papel.includes(roles.ROLE_GESTOR));
        const possuiPermisaoEnvioUnicoToi = (this.props.auth.user.papel.includes(roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO) && this.props.auth.user.papel.includes(roles.ROLE_GESTOR));
        const possuiPermissaoAdministrador = this.props.auth.user.papel.includes(roles.ROLE_ADMINISTRADOR);
        const possuiPermissaoTemplates = possuiPermissaoGestorCarimboTempo || possuiPermisaoEnvioUnicoToi || possuiPermissaoAdministrador;

        return (
            <div className="row border-bottom white-bg mx-0">
                <nav className="navbar navbar-expand-lg navbar-static-top" style={{ height: "51px" }} role="navigation">

                    <Link to={c.PANEL_ROUTE} className="navbar-header">
                        <div>
                            <img src="assets/images/logo-moisate.svg" />
                        </div>
                    </Link>

                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fa fa-reorder"></i>
                    </button>
                    <div className="navbar-collapse collapse" id="navbar">
                        <ul className="nav navbar-nav">

                            <TemPermissao permissoes={[roles.ROLE_EMAIL, roles.ROLE_SMS]}>
                                <li className={"dropdown " + (this.props.navActiveItem === c.NAV_PANEL ? 'active' : '')} title="Painel">
                                    <Link to={c.PANEL_ROUTE}>
                                        <i className="fa fa-inbox" aria-hidden="true"></i>Painel
                                    </Link>
                                </li>
                                <li className={"dropdown " + (this.props.navActiveItem === c.NAV_CAMPAIGN ? 'active' : '')} title="Campanhas">
                                    <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-calendar" aria-hidden="true"></i>Campanhas
                                    </a>

                                    <ul role="menu" className="dropdown-menu">
                                        <NavHeader>Listas</NavHeader>
                                        <li><Link to={c.CAMPAIGN_ROUTE + "/lista"} className="text-nowrap">Listas</Link></li>

                                        <NavHeader>Campanha</NavHeader>
                                        <TemPermissao permissao={roles.ROLE_EMAIL}>
                                            <li><Link to={c.CAMPAIGN_ROUTE + "/nova"} className="text-nowrap">Email</Link></li>
                                        </TemPermissao>
                                        <TemPermissao permissao={roles.ROLE_SMS}>
                                            <li><Link to={c.CAMPAIGN_ROUTE + "/nova-sms"} className="text-nowrap">Sms</Link></li>
                                        </TemPermissao>

                                        <NavHeader>Template</NavHeader>
                                        <TemPermissao permissao={roles.ROLE_EMAIL}>
                                            <li><Link to={c.CAMPAIGN_ROUTE + "/templates"} className="text-nowrap">Email</Link></li>
                                        </TemPermissao>
                                        <TemPermissao permissao={roles.ROLE_SMS}>
                                            <li><Link to={c.CAMPAIGN_ROUTE + "/template-sms"} className="text-nowrap">Sms</Link></li>
                                        </TemPermissao>

                                        <TemPermissao permissao={roles.ROLE_ADMINISTRADOR}>
                                            <NavHeader>Adesão</NavHeader>
                                            <li><Link to={c.CAMPAIGN_ROUTE + "/adesao-campos"} className="text-nowrap">Campos</Link></li>
                                        </TemPermissao>

                                    </ul>
                                </li>
                            </TemPermissao>
                            <li className={"dropdown " + (this.props.navActiveItem === c.NAV_REPORT ? 'active' : '')} title="Relatório">
                                <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                    <i className="fa fa-file-text-o" aria-hidden="true"></i>Relatório
                                </a>

                                <ul role="menu" className="dropdown-menu">
                                    <TemPermissao permissoes={[roles.ROLE_EMAIL, roles.ROLE_SMS]}>
                                        <li><Link to={c.REPORT_ROUTE + "/envio-rastreado"} className="text-nowrap">Envio Rastreado</Link></li>
                                    </TemPermissao>
                                    <TemPermissao permissoes={[roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO, roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO]}>
                                        <li><Link to={c.REPORT_ROUTE + "/verifica-montreal-toi"} className="text-nowrap">Verifica Montreal</Link></li>
                                    </TemPermissao>
                                    <li><Link to={c.REPORT_ROUTE + "/download-relatorio"} className="text-nowrap">Download Relatório</Link></li>
                                    <TemPermissao permissao={roles.ROLE_EMAIL}>
                                        <li><Link to={c.REPORT_ROUTE + "/graficos"} className="text-nowrap">Gráficos</Link></li>
                                    </TemPermissao>
                                </ul>
                            </li>
                            <TemPermissao permissoes={[roles.ROLE_EMAIL, roles.ROLE_SMS]}>
                                <TemPermissao permissao={roles.ROLE_EMAIL}>
                                    <li className={"dropdown " + (this.props.navActiveItem === c.NAV_VALIDATION ? 'active' : '')} title="Validação E-mail">
                                        <Link to={c.VALIDATION_ROUTE}>
                                            <i className="fa fa-envelope-open-o" aria-hidden="true"></i>Validação E-mail
                                        </Link>
                                    </li>
                                </TemPermissao>
                                <TemPermissao permissao={roles.ROLE_SMS}>
                                    <li className={"dropdown " + (this.props.navActiveItem === c.NAV_ENVO_SMS ? 'active' : '')} title="Envio SMS">
                                        <Link to={c.ENVIO_SMS_ROUTE}>
                                            <i className="fa fa-mobile fa-lg" aria-hidden="true"></i>Envio SMS
                                        </Link>
                                    </li>
                                </TemPermissao>
                            </TemPermissao>


                            <TemPermissao permissoes={[roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO, roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO]}>
                                <li className={"dropdown " + (this.props.navActiveItem === c.NAV_VERIFICA_MONTREAL ? 'active' : '')} title="Verifica Montreal">
                                    <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-list-alt" aria-hidden="true"></i>Carimbo
                                    </a>
                                    <ul role="menu" className="dropdown-menu">
                                        <TemPermissao permissao={roles.ROLE_ADMINISTRADOR}>
                                            <NavHeader>Validação</NavHeader>
                                            <li><Link to={c.STAMP_ROUTE + "/listaCelularUpload"} className="text-nowrap">Validação Celular</Link></li>
                                        </TemPermissao>
                                        <TemPermissao permissoes={[roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO]}>
                                            <NavHeader>Upload</NavHeader>
                                            <li><Link to={c.STAMP_ROUTE + "/upload-toi"} className="text-nowrap">Upload arquivos zip</Link></li>
                                            <li><Link to={c.STAMP_ROUTE + "/upload-partes"} className="text-nowrap">Upload Mailing</Link></li>
                                            <li><Link to={c.STAMP_ROUTE + "/status-mailing"} className="text-nowrap">Upload Anexos</Link></li>
                                            <li><Link to={c.STAMP_ROUTE + "/agendamento-upload"} className="text-nowrap">Status upload</Link></li>
                                        </TemPermissao>
                                        <NavHeader>Laudo</NavHeader>
                                        <TemPermissao permissoes={[roles.ROLE_LAUDO_LOTE]}>
                                            <li><Link to={c.STAMP_ROUTE + "/agendamento"} className="text-nowrap">Agendamento em lote</Link></li>
                                        </TemPermissao>
                                        <li><Link to={c.STAMP_ROUTE + "/laudo-download"} className="text-nowrap">Download único</Link></li>
                                        <TemPermissao permissaoBoolean={possuiPermissaoTemplates}>
                                            <NavHeader>Template</NavHeader>
                                            <TemPermissao permissoes={[roles.ROLE_CARIMBO_TEMPO_EMAIL]}>
                                                <li><Link to={c.STAMP_ROUTE + "/templates"} className="text-nowrap">Template Email</Link></li>
                                            </TemPermissao>
                                            <TemPermissao permissoes={[roles.ROLE_CARIMBO_TEMPO_SMS]}>
                                                <li><Link to={c.STAMP_ROUTE + "/templatesSMS"} className="text-nowrap">Template SMS</Link></li>
                                            </TemPermissao>
                                        </TemPermissao>
                                        <TemPermissao permissoes={[roles.ROLE_ADMINISTRADOR, roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO]}>
                                            <NavHeader>Envio único</NavHeader>
                                            <li><Link to={c.STAMP_ROUTE + "/envioUnico"} className="text-nowrap">Envio Mailing único</Link></li>
                                        </TemPermissao>
                                    </ul>
                                </li>
                            </TemPermissao>
                        </ul>

                        <ul className="nav navbar-top-links navbar-right">
                            <li className="dropdown">
                                <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                    <i className="fa fa-user-circle-o" aria-hidden="true"></i> {auth.user.name}
                                </a>
                                <ul role="menu" className="dropdown-menu">
                                    <TemPermissao permissao={roles.ROLE_SIMPLES}>
                                        <MenuSimples headProps={this.props} />
                                    </TemPermissao>

                                    <TemPermissao permissao={roles.ROLE_GESTOR}>
                                        <MenuGestor headProps={this.props} />
                                    </TemPermissao>

                                    <TemPermissao permissao={roles.ROLE_ADMINISTRADOR}>
                                        <MenuAdministrador headProps={this.props} />
                                    </TemPermissao>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

class MenuGestor extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            headProps: null,
            loading: false
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {

        this.state.headProps = this.props.headProps;

    }

    handleLogout(e) {
        e.preventDefault(); if (this.state.loading) return;

        this.setState({ loading: true });

        Promise.resolve(logout(this.state.headProps)).then(() => { this.setState({ loading: false }); });

    }

    render() {
        return (
            <div>
                <li><Link to={c.REPORT_USUARIO + "/alterar-senha"} className="text-nowrap">Alterar Senha</Link></li>
                <TemPermissao permissao={roles.ROLE_EMAIL}>
                    <li><Link to={c.REPORT_USUARIO + "/configuracao"} className="text-nowrap">Configuração</Link></li>
                </TemPermissao>
                <li><Link to={c.REPORT_USUARIO + "/usuarios"} className="text-nowrap">Usuários</Link></li>
                <li><Link to={c.DEFAULT_PUBLIC_ROUTE} id="btnSairGestor" className="text-nowrap" onClick={this.handleLogout}>Sair</Link></li>
            </div>
        );
    }
}

class MenuSimples extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            headProps: null,
            loading: false
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {

        this.state.headProps = this.props.headProps;

    }

    handleLogout(e) {
        e.preventDefault(); if (this.state.loading) return;

        this.setState({ loading: true });

        Promise.resolve(logout(this.state.headProps)).then(() => { this.setState({ loading: false }); });
    }

    render() {
        return (
            <div>
                <li><Link to={c.REPORT_USUARIO + "/alterar-senha"} className="text-nowrap">Alterar Senha</Link></li>
                <li><Link to={c.DEFAULT_PUBLIC_ROUTE} id="btnSairSimples" className="text-nowrap" onClick={this.handleLogout}>Sair</Link></li>
            </div>
        );
    }
}

class MenuAdministrador extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            headProps: null,
            loading: false
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {

        this.state.headProps = this.props.headProps;

    }

    handleLogout(e) {
        e.preventDefault(); if (this.state.loading) return;

        this.setState({ loading: true });

        Promise.resolve(logout(this.state.headProps)).then(() => { this.setState({ loading: false }); });

    }

    render() {
        return (
            <div>
                <li><Link to={c.REPORT_USUARIO + "/alterar-senha"} className="text-nowrap">Alterar Senha</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/configuracao"} className="text-nowrap">Configuração</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/usuarios"} className="text-nowrap">Usuários</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/empresas"} className="text-nowrap">Empresas</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/campos"} className="text-nowrap">Campos</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/produtos"} className="text-nowrap">Produtos</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/centrocusto"} className="text-nowrap">Centro Custo</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/gerenciadordominio"} className="text-nowrap">Domínios</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/remetentes-validos"} className="text-nowrap">Remetentes Válidos</Link></li>
                <li><Link to={c.REPORT_USUARIO + "/seguranca"} className="text-nowrap">Segurança</Link></li>
                <li><Link to={c.DEFAULT_PUBLIC_ROUTE} id="btSair" className="text-nowrap" onClick={this.handleLogout}>Sair</Link></li>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: { auth: bindActionCreators(authActionPrivate, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
